import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/coreTop.png'
import _imports_1 from '../../assets/images/coreBottom.png'
import _imports_2 from '../../assets/images/content2.jpg'
import _imports_3 from '../../assets/images/texture.gif'


const _withScopeId = n => (_pushScopeId("data-v-5a1e60bd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "coreCnetentLeft",
  style: {"margin-bottom":"60px"}
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" > ")
const _hoisted_3 = { class: "coreCnetentLeftBody" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 0,
  src: _imports_1,
  alt: ""
}
const _hoisted_7 = {
  key: 0,
  class: "coreCnetentLeftTo"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tap1-image-animation",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "titleto" }
const _hoisted_11 = { class: "coreCnetentLeftToDes" }
const _hoisted_12 = {
  key: 1,
  class: "coreCnetentLeftTo"
}
const _hoisted_13 = { class: "coreCnetentLeftToBody textureBack" }
const _hoisted_14 = { class: "title" }
const _hoisted_15 = { class: "titleto" }
const _hoisted_16 = { class: "coreCnetentLeftToDes" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "texture",
  src: _imports_3,
  alt: ""
}, null, -1))

import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ZhCoreFunctionsTab1',
  setup(__props) {

const coreCnetentRef = ref(true);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(["coreCnetentLeftTab", coreCnetentRef.value ? 'active' : '']),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (coreCnetentRef.value = true))
      }, [
        (coreCnetentRef.value)
          ? (_openBlock(), _createElementBlock("img", _hoisted_4))
          : _createCommentVNode("", true),
        _createElementVNode("p", {
          innerHTML: _ctx.$t('home.tap1_button_text1')
        }, null, 8, _hoisted_5),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("home.tap1_button_text2")), 1)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["Material", coreCnetentRef.value ? '' : 'active']),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (coreCnetentRef.value = false)),
        style: {"padding-left":"34px"}
      }, [
        (!coreCnetentRef.value)
          ? (_openBlock(), _createElementBlock("img", _hoisted_6))
          : _createCommentVNode("", true),
        _createElementVNode("p", {
          style: _normalizeStyle({
            color: coreCnetentRef.value ? '#52595d' : '#fff',
          })
        }, _toDisplayString(_ctx.$t("home.tap1_propertie_effects")), 5)
      ], 2)
    ]),
    (coreCnetentRef.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", {
            class: _normalizeClass(["coreCnetentLeftToBody", coreCnetentRef.value ? 'coreCnetentLeftToBodyGradlent' : ''])
          }, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("home.core_funs_contents1_top")), 1),
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("home.core_funs_contents1_center")), 1),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("home.core_funs_contents1_bom")), 1)
          ], 2)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("home.core_funs_contents2_top")), 1),
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("home.core_funs_contents2_center")), 1),
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("home.core_funs_contents2_bom")), 1)
          ])
        ])),
    _hoisted_17
  ]))
}
}

})